import {library} from "@fortawesome/fontawesome-svg-core";
import {
  faExclamationTriangle,
  faPhoneAlt,
  faUser,
  faLock,
  faTimesCircle,
  faExclamationCircle,
  faCheckCircle,
  faChevronCircleUp,
  faUserCircle,
  faSearch,
  faThList,
  faBorderAll,
  faHammer,
  faHeart,
  faEye,
  faShoppingBasket,
  faCheck,
  faShoppingCart,
  faTimes,
  faBars,
  faChevronDown,
  faGavel,
  faClock,
  faBatteryFull,
  faPhone,
  faStopwatch,
  faWindowMaximize,
  faArrowRight,
  faMapMarker,
  faStar,
  faTruck,
  faMapMarkerAlt,
  faEnvelope,
  faAngleDoubleRight,
  faLongArrowAltRight,
  faTabletAlt,
  faTv,
  faAdjust,
  faBook,
  faAngleDown,
  faCogs,
  faEnvelopeOpenText,
  faAlignLeft,
  faTablet,
  faDesktop,
  faLaptop,
  faGamepad,
  faSpa,
  faMobile,
  faExpandArrowsAlt,
  faSearchPlus,
  faSearchMinus,
  faWheelchair
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faExclamationTriangle,
  faPhoneAlt,
  faUser,
  faLock,
  faTimesCircle,
  faExclamationCircle,
  faCheckCircle,
  faChevronCircleUp,
  faUserCircle,
  faSearch,
  faThList,
  faBorderAll,
  faHammer,
  faHeart,
  faEye,
  faShoppingBasket,
  faCheck,
  faShoppingCart,
  faTimes,
  faBars,
  faChevronDown,
  faGavel,
  faClock,
  faBatteryFull,
  faPhone,
  faStopwatch,
  faExclamationCircle,
  faWindowMaximize,
  faArrowRight,
  faMapMarker,
  faStar,
  faTruck,
  faMapMarkerAlt,
  faEnvelope,
  faAngleDoubleRight,
  faLongArrowAltRight,
  faTabletAlt,
  faTv,
  faAdjust,
  faBook,
  faAngleDown,
  faCogs,
  faEnvelopeOpenText,
  faAlignLeft,
  faTablet,
  faDesktop,
  faLaptop,
  faGamepad,
  faSpa,
  faMobile,
  faExpandArrowsAlt,
  faSearchPlus,
  faSearchMinus,
  faWheelchair
);
